import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const RoleRoute = ({ allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) return <div>Cargando...</div>;

  if (!user) return <Navigate to="/login" replace />;

  // if (!allowedRoles.includes(user.role)) {
  //   return <Navigate to="/session/profile" replace />;
  // }

  if (!allowedRoles.includes(user.role)) {
  return (
    <div className="text-center mt-5">
      <h4>No tienes permisos para acceder a este módulo</h4>
    </div>
  );
}
  return <Outlet />;
};


export default RoleRoute;
